<script lang="ts">
    import GroupCommunityPicker from './GroupCommunityPicker.svelte';
    import { getRequest } from './Util/utils';
    import route from './Util/routes';

    export let csrf_token;
    export let onComplete = ()=>{};
    export let onDeselect = ()=>{};

    let group_communities = [];
    let picker: GroupCommunityPicker;

    export function submitCommunity(){
        picker.submit();
    }

    function updateGroupCommunities() {
        return window.fetch(route('UserController@getGroupCommunities'), {
            ...getRequest(),
            method: 'get',
        })
        .then(response => response.json())
        .then(data => {
            group_communities = data.group_communities ?? [];
        }).catch(error=>{
            console.log(error)
        });
    }
    void updateGroupCommunities();
</script>

<GroupCommunityPicker bind:this={picker} onDeselect={onDeselect} onComplete={onComplete} group_communities={group_communities}/>